




import {
  Component,
  Vue,
} from 'vue-property-decorator';


@Component({
  name: 'loader-spinner',
})
export default class LoaderSpinner extends Vue {

}
